import Vue from 'vue'
import VueRouter from 'vue-router'

import Index from '../views/Index'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Index
  }
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  document.title = 'Login AmoDelivery'
  next()
})

export default router
